import { getDateVal } from "@/pages/dashboard/utils/utils";
import moment, { isMoment, Moment } from "moment";

// 日期格式化
export const formatDateFromFilterValue = (value: any): any => {
  const { date } = value || {};
  const [start, end] = date;
  const startDate = getDateVal(start, 'YYYY-MM-DD');
  const endDate = getDateVal(end, 'YYYY-MM-DD');
  return {
    ...value,
    date: [startDate, endDate],
    isSingle: startDate === endDate,
  };
};

export const getMomentDate = (value: Moment | string) => {
  return isMoment(value) ? value : moment(value);
};